import { useTheme } from '@material-ui/core';
import { B2ChatLogoDesktop } from '@src/resources';

const B2ChatLogoSvg = () => {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <img
      src={B2ChatLogoDesktop}
      alt="B2Chat"
      style={{
        height: 32,
        filter: isDark ? 'brightness(0) invert(1)' : 'none',
      }}
    />
  );
};

export default B2ChatLogoSvg;
